import { useState } from "react";
import styled from "styled-components";
import CustomNetworkImage from "./CustomNetworkImage";
import { Theme } from "../../Theme";

const EmptyThumbnail = styled.div`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    border-radius: ${(props) => props.borderRadius};
    background-color: ${Theme.color.gray200};
    flex-shrink: 0;
`;

/**
 * 매장 이미지. URL 이 비어있거나 로드 실패 시 회색 박스로 대체.
 * (프로젝트에 공용 default 이미지 자산이 없어 회색 박스를 사용)
 */
function StoreThumbnail({ src, size = "40px", borderRadius = "100%" }) {
    const [hasError, setHasError] = useState(false);

    if (!src || hasError) {
        return <EmptyThumbnail size={size} borderRadius={borderRadius} />;
    }

    return <CustomNetworkImage src={src} size={size} borderRadius={borderRadius} onError={() => setHasError(true)} />;
}

export default StoreThumbnail;
